import React, { Component, Fragment } from "react"
import {
    objectPicker,
    objectFilters,
    objectOrder,
} from "features/editor/attributes/items/primitives"
import { direction as directionContext } from "features/editor/ContextProviders"
import WithRecords from "data/wrappers/WithRecords"
import RenderTree from "../../RenderTree"
import { TreeInstance } from "features/editor/tree/tree"
import { Container } from "ui"
import { record as recordContext } from "features/editor/ContextProviders"
import { processFilter } from "features/records/components/RecordFilters"
import { processOrder } from "features/records/components/RecordOrder"
import DefineProperty from "../../properties/DefineProperty"

/**
 * @augments {Component<BlockTypeProps<{text: string}>, any>}
 */
export default class DataRepeaterBlock extends Component {
    state = { edits: { edit: null, callback: null } }

    filterAndOrder = (data, attrs, evaluateFormulas) => {
        let result
        result = processFilter(data || [{}], evaluateFormulas(attrs.dataFilters))
        result = processOrder(result, attrs.order && [attrs.order])

        return result
    }
    render() {
        const Wrapper = this.props.Wrapper

        const renderItem = record => {
            let tree = new TreeInstance(this.props.childBlocks)
            // console.log(record)
            return (
                <recordContext.Provider value={record}>
                    <RenderTree inline instance={tree} />
                </recordContext.Provider>
            )
        }

        return (
            <Wrapper {...this.props} style={{ ...this.props.style, display: "flex" }}>
                {({ attrs, computedStyle, updateAttributes, evaluateFormulas, selected }) => (
                    <directionContext.Provider value={computedStyle.flexDirection || "column"}>
                        <Container style={{ ...computedStyle, maxWidth: "100%", width: "100%" }}>
                            <WithRecords ignoreLoading objectId={attrs.objectId}>
                                {({ records }) => {
                                    return (
                                        <Fragment>
                                            {this.filterAndOrder(
                                                records,
                                                attrs,
                                                evaluateFormulas
                                            ).map(renderItem)}
                                            <DefineProperty
                                                name="count"
                                                description="count of items"
                                                type="string"
                                                value={
                                                    this.filterAndOrder(
                                                        records,
                                                        attrs,
                                                        evaluateFormulas
                                                    ).length
                                                }
                                                //onPersistedValue={value => this.setState({ value })}
                                            />
                                        </Fragment>
                                    )
                                }}
                            </WithRecords>
                        </Container>
                    </directionContext.Provider>
                )}
            </Wrapper>
        )
    }
}

DataRepeaterBlock.attributes = [
    objectPicker({ field: "objectId", label: "Data source" }),
    objectFilters({ field: "dataFilters", label: "data filters" }),
    objectOrder({ field: "order", label: "default ordering" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/data/DataRepeaterBlock.js